import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { DetectionTestBase } from "../DetectionTestBase";

interface Props {
  isLoading: boolean;
  isVPNDetected: boolean;
  hasDivider?: boolean;
  isNotification?: boolean;
}

export const VPNDetection = ({
  isLoading,
  isVPNDetected,
  hasDivider = true,
  isNotification,
}: Props): JSX.Element => {
  const { t } = useI18n(["micCamCheck", "url"]);

  return (
    <DetectionTestBase
      testName={
        isVPNDetected ? t("micCamCheck:vpn.detected") : t("micCamCheck:vpn")
      }
      testResult={
        <Typography variant="body1">
          {isVPNDetected &&
            !isNotification &&
            t("micCamCheck:vpn.detected.message")}
          {isVPNDetected &&
            isNotification &&
            t("micCamCheck:vpn.notification.detected.message")}
          {!isVPNDetected && t("micCamCheck:vpn.not.detected")}
        </Typography>
      }
      troubleShootLink={t("url:troubleshoot.vpn")}
      showTroubleshootLink={isVPNDetected}
      isRecommendation
      hasDivider={hasDivider}
      isLoading={isLoading}
    />
  );
};
